module.exports = __webpack_public_path__ + "img/img-up.9b27d35f.svg";